import apiAgent from "../../api/apiAgent";
import { useEffect, useState } from "react";
import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import { Link, redirect, useNavigate, useParams } from "react-router-dom";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import _ from "lodash";
import { DisplayValue } from "../../components/DisplayValue";
import { EditButton } from "../../components/Button";
import { checkTitle } from "../../utils";
import { tMsg } from "../../components/ToastNotifications";

const BaseSingleItem = (): JSX.Element => {
  const navigate = useNavigate();
  const params = useParams();

  const itemName = params.item?.toString() || "unknown";
  const [data, setData] = useState<any>(null);
  const [itemKeys, setItemKeys] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      const response = await apiAgent.SingleItem.get(itemName);
      // console.log(response);

      if (response.status === 200) {
        const jsonData = JSON.parse(response.data.data);
        const displayData = {
          ...jsonData,
          updatedAt: response.data.updated_at,
        };
        const getKeys = Object.keys(displayData);
        setItemKeys(getKeys);
        setData(displayData);
      } else {
        tMsg.error(`${itemName} does not exist`);
        navigate("/error");
      }
    } catch (err) {
      console.log(err);
      redirect("/error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [itemName]);

  return (
    <PageContainer isLoading={isLoading} className="relative">
      <PageContent>
        <BreadCrumbs crumbs={[]} />
        <TitleBar title={checkTitle(itemName)}>
          <Link to={`/si/${itemName}/edit`}>
            <EditButton />
          </Link>
        </TitleBar>
        <div className="flex flex-col gap-4">
          {itemKeys.map((itemKey: any, index: number) => (
            <DisplayValue
              key={index}
              name={itemKey}
              value={data[itemKey]}
              type={"wysiwyg"}
            />
          ))}
        </div>
      </PageContent>
      <PageFooterBar>
        <Link to={`/si/${itemName}/edit`}>
          <EditButton />
        </Link>
      </PageFooterBar>
    </PageContainer>
  );
};

export default BaseSingleItem;
